import Link from "next/link"
import { cn } from "@/lib/utils"
import { business } from "@/lib/business"

export function BrandLink({ className }: { className?: string }) {
    return (
        <div className={cn("flex items-center gap-2 font-quicksand", className)}>
            <Link href="/" className="text-xl text-white uppercase">
                {business.name}
            </Link>
        </div>
    )
} 